import { Messages } from '~src/codegen/Localize';

import { ClusterNodeStatus } from './ClusterNodeStatus';

export type NodeStatus = Readonly<{
  stateLabel: string;
  stateText:  string;
  stateImage: string;
  stateClass: string;
}>;

/*
 * Register remote node status here for the node presence icon
 */
export function getClusterNodeStatus() {
  return {
    'Node Unaccepted': {
      stateLabel: Messages.dataConnectSiteSettingsClusterNodeStatusUnavailable(),
      stateText: Messages.dataConnectSiteSettingsClusterNodeStatusUnavailable(),
      stateImage: 'status_down_14px-small.svg',
      stateClass: 'tb-cluster-node-presence-icon tb-cluster-node-presence-connected'
    },
    'Available': {
      stateLabel: Messages.dataConnectSiteSettingsClusterNodeStatusAvailable(),
      stateText: Messages.dataConnectSiteSettingsClusterNodeStatusAvailable(),
      stateImage: 'status_active_14px_small.svg',
      stateClass: 'tb-cluster-node-presence-icon tb-cluster-node-presence-connected'
    },
    'Provisioning': {
      stateLabel: Messages.dataConnectSiteSettingsClusterNodeStatusProvisioning(),
      stateText: Messages.dataConnectSiteSettingsClusterNodeStatusProvisioning(),
      stateImage: 'status_inprogress_14px-small.svg',
      stateClass: 'tb-cluster-node-presence-icon tb-cluster-node-presence-not-connected'
    },
    'Unavailable': {
      stateLabel: Messages.dataConnectSiteSettingsClusterNodeStatusUnavailable(),
      stateText: Messages.dataConnectSiteSettingsClusterNodeStatusUnavailable(),
      stateImage: 'status_error_14px-small.svg',
      stateClass: 'tb-cluster-node-presence-icon tb-cluster-node-presence-not-connected'
    }
  } as { readonly [s in ClusterNodeStatus]: NodeStatus };
}
